import { createSlice } from "@reduxjs/toolkit";

import {
  confirmDeposit,
  confirmC2CDeposit,
  uploadReceiptC2C,
} from "../thunks/Payment";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(confirmDeposit.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(confirmDeposit.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(confirmDeposit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(confirmC2CDeposit.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(confirmC2CDeposit.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(confirmC2CDeposit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(uploadReceiptC2C.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadReceiptC2C.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(uploadReceiptC2C.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const paymentReducer = paymentSlice.reducer;
